document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('dynamic-modal');
  const modalBody  = modal.querySelector('.modal__body');
  const closeBtn = modal.querySelector('.modal__close');

  document.querySelectorAll('[data-popup-link]').forEach(link => {
    link.addEventListener('click', e => {
      var uriToFetch = (e.currentTarget.getAttribute('href') || '/pages/size-chart') + '?section_id=main-page';
      e.preventDefault();
      fetch(uriToFetch).then(r => r.text()).then(html => {
        modalBody.innerHTML = html;
        modal.classList.add('is-open');
        if (uriToFetch.includes('size-chart')) {
          modal.classList.add('size-chart');
        }
      });
      //modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    });
  });

  closeBtn.addEventListener('click', () => {
    modal.classList.remove('is-open', 'size-chart');
    modal.setAttribute('aria-hidden', 'true');
    // frame.src = '';                // reset to free memory
  });

  modal.addEventListener('click', () => {
    modal.classList.remove('is-open', 'size-chart');
    modal.setAttribute('aria-hidden', 'true');
    // frame.src = '';                // reset to free memory
  });
  
  // Close on ESC
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeBtn.click();
    }
  });
});
